module.exports = __webpack_public_path__ + "static/media/content-ad.7ceac562.jpg";